<template>
  <FloatingCard class="stack stack--small" :feeling="feeling">
    <p>Vyberte firmu, kterou chcete nastavit:</p>
    <SelectionGroup
      v-model="selected"
      type="radio"
      name="companies"
      :options="companiesSelectionOptions"
    />
  </FloatingCard>
</template>

<script>
import SelectionGroup from '@/components/SelectionGroup';
import FloatingCard from '@/components/FloatingCard';

import Flexi from '@/mixins/Flexi';

export default {
  name: 'FlexiCompaniesListCard',
  components: {
    SelectionGroup,
    FloatingCard,
  },
  mixins: [
    Flexi,
  ],
  props: {
    apiURL: {
      type: String,
    },
    username: {
      type: String,
    },
    password: {
      type: String,
    },
    token: {
      type: String,
    },
  },
  data() {
    return {
      status: null,
      companies: [],
      selected: '',
    };
  },
  computed: {
    feeling() {
      switch (this.status) {
        case 'listing-companies':
          return 'pending';
        case 'companies-listed':
          return 'positive';
        case 'something-wrong':
          return 'negative';
        default:
          return null;
      }
    },
    companiesSelectionOptions() {
      return this.companies.map((company) => ({
        id: company.id,
        label: company.name,
      }));
    },
  },
  watch: {
    status() {
      this.$emit('status-change', { status: this.status, data: this.$data });
    },
    selected() { this.onSelectedChange(); },
  },
  methods: {
    async listCompanies() {
      try {
        this.status = 'listing-companies';
        const companies = await this.$_Flexi_listCompanies({
          apiURL: this.apiURL,
          username: this.username,
          password: this.password,
          token: this.token,
        });
        this.companies = companies;
        this.status = 'companies-listed';
      } catch (error) {
        this.status = 'something-wrong';
        throw error;
      }
    },
    onSelectedChange() {
      this.$emit('change', this.selected);
    },
  },
  mounted() {
    this.listCompanies();
  },
  beforeDestroy() {
    this.companies = [];
    this.selected = '';
    this.onSelectedChange();
  },
};
</script>
